module.exports = __webpack_public_path__ + "static/assets/0e370ab3cadb27d9b1271cb732ec5fc5.png";